export class AuthSignInClass {
  static _SendUserInfoData() {
   return [
      {
        FirstName: "DEV Environment",
        LastName: "DEV Environment",
        SysNumber: 2986943897,
        Email: "mk11@amadeosystems.com",
        Status: 2,
        Pin: null,
        PersonID: 2,
        AccessMethod: 0,
        CookiesAgreement: "0001-01-01T00:00:00",
        CookiesOption: 0,
        AppCLientPersonRoles: [
          {
            RoleID: 1,
            RoleName: "Role_IA1",
            Permission: [
              {
                AppCLientPermissionID: 1,
                _AppCLientRoleID: 1,
                _Permission: 4100,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 2,
                _AppCLientRoleID: 1,
                _Permission: 4101,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 3,
                _AppCLientRoleID: 1,
                _Permission: 4102,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 4,
                _AppCLientRoleID: 1,
                _Permission: 4103,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 5,
                _AppCLientRoleID: 1,
                _Permission: 4120,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 6,
                _AppCLientRoleID: 1,
                _Permission: 4121,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 7,
                _AppCLientRoleID: 1,
                _Permission: 4122,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 8,
                _AppCLientRoleID: 1,
                _Permission: 4140,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 9,
                _AppCLientRoleID: 1,
                _Permission: 4141,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 10,
                _AppCLientRoleID: 1,
                _Permission: 4160,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 11,
                _AppCLientRoleID: 1,
                _Permission: 4161,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 12,
                _AppCLientRoleID: 1,
                _Permission: 4162,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 13,
                _AppCLientRoleID: 1,
                _Permission: 4163,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 14,
                _AppCLientRoleID: 1,
                _Permission: 4180,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 15,
                _AppCLientRoleID: 1,
                _Permission: 4181,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 16,
                _AppCLientRoleID: 1,
                _Permission: 4182,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 17,
                _AppCLientRoleID: 1,
                _Permission: 4200,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 18,
                _AppCLientRoleID: 1,
                _Permission: 4201,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 19,
                _AppCLientRoleID: 1,
                _Permission: 4202,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 20,
                _AppCLientRoleID: 1,
                _Permission: 4203,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 21,
                _AppCLientRoleID: 1,
                _Permission: 4204,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 22,
                _AppCLientRoleID: 1,
                _Permission: 4205,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 23,
                _AppCLientRoleID: 1,
                _Permission: 4220,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 24,
                _AppCLientRoleID: 1,
                _Permission: 4221,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 25,
                _AppCLientRoleID: 1,
                _Permission: 4222,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 26,
                _AppCLientRoleID: 1,
                _Permission: 4223,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 27,
                _AppCLientRoleID: 1,
                _Permission: 4224,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 28,
                _AppCLientRoleID: 1,
                _Permission: 4225,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 29,
                _AppCLientRoleID: 1,
                _Permission: 4240,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 30,
                _AppCLientRoleID: 1,
                _Permission: 4241,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 31,
                _AppCLientRoleID: 1,
                _Permission: 4242,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 32,
                _AppCLientRoleID: 1,
                _Permission: 4260,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 33,
                _AppCLientRoleID: 1,
                _Permission: 4261,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 34,
                _AppCLientRoleID: 1,
                _Permission: 4262,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 35,
                _AppCLientRoleID: 1,
                _Permission: 4263,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 36,
                _AppCLientRoleID: 1,
                _Permission: 4264,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 37,
                _AppCLientRoleID: 1,
                _Permission: 4280,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 38,
                _AppCLientRoleID: 1,
                _Permission: 4281,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 39,
                _AppCLientRoleID: 1,
                _Permission: 4282,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 40,
                _AppCLientRoleID: 1,
                _Permission: 4283,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 41,
                _AppCLientRoleID: 1,
                _Permission: 4284,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 42,
                _AppCLientRoleID: 1,
                _Permission: 4285,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 43,
                _AppCLientRoleID: 1,
                _Permission: 4300,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 44,
                _AppCLientRoleID: 1,
                _Permission: 4301,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 45,
                _AppCLientRoleID: 1,
                _Permission: 4302,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 46,
                _AppCLientRoleID: 1,
                _Permission: 4303,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 47,
                _AppCLientRoleID: 1,
                _Permission: 4304,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 48,
                _AppCLientRoleID: 1,
                _Permission: 4320,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 49,
                _AppCLientRoleID: 1,
                _Permission: 4321,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 50,
                _AppCLientRoleID: 1,
                _Permission: 4323,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 51,
                _AppCLientRoleID: 1,
                _Permission: 4340,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 52,
                _AppCLientRoleID: 1,
                _Permission: 4341,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 53,
                _AppCLientRoleID: 1,
                _Permission: 4342,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 54,
                _AppCLientRoleID: 1,
                _Permission: 4343,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 55,
                _AppCLientRoleID: 1,
                _Permission: 4360,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 56,
                _AppCLientRoleID: 1,
                _Permission: 4361,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 57,
                _AppCLientRoleID: 1,
                _Permission: 4362,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 58,
                _AppCLientRoleID: 1,
                _Permission: 4380,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 59,
                _AppCLientRoleID: 1,
                _Permission: 4381,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 60,
                _AppCLientRoleID: 1,
                _Permission: 4382,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 61,
                _AppCLientRoleID: 1,
                _Permission: 4400,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 62,
                _AppCLientRoleID: 1,
                _Permission: 4401,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 63,
                _AppCLientRoleID: 1,
                _Permission: 4402,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 64,
                _AppCLientRoleID: 1,
                _Permission: 4403,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 65,
                _AppCLientRoleID: 1,
                _Permission: 4404,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 66,
                _AppCLientRoleID: 1,
                _Permission: 4405,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 67,
                _AppCLientRoleID: 1,
                _Permission: 4406,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 68,
                _AppCLientRoleID: 1,
                _Permission: 4407,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 69,
                _AppCLientRoleID: 1,
                _Permission: 4408,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 70,
                _AppCLientRoleID: 1,
                _Permission: 4409,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
            ],
          },
          {
            RoleID: 2,
            RoleName: "Role_Client1",
            Permission: [
              {
                AppCLientPermissionID: 71,
                _AppCLientRoleID: 2,
                _Permission: 1,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 72,
                _AppCLientRoleID: 2,
                _Permission: 2,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 73,
                _AppCLientRoleID: 2,
                _Permission: 5,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 74,
                _AppCLientRoleID: 2,
                _Permission: 9,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 75,
                _AppCLientRoleID: 2,
                _Permission: 11,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 76,
                _AppCLientRoleID: 2,
                _Permission: 15,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 77,
                _AppCLientRoleID: 2,
                _Permission: 20,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 78,
                _AppCLientRoleID: 2,
                _Permission: 30,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 79,
                _AppCLientRoleID: 2,
                _Permission: 40,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 80,
                _AppCLientRoleID: 2,
                _Permission: 100,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 81,
                _AppCLientRoleID: 2,
                _Permission: 200,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 82,
                _AppCLientRoleID: 2,
                _Permission: 300,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 83,
                _AppCLientRoleID: 2,
                _Permission: 400,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 84,
                _AppCLientRoleID: 2,
                _Permission: 500,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 85,
                _AppCLientRoleID: 2,
                _Permission: 600,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 86,
                _AppCLientRoleID: 2,
                _Permission: 700,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 87,
                _AppCLientRoleID: 2,
                _Permission: 800,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 88,
                _AppCLientRoleID: 2,
                _Permission: 900,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 89,
                _AppCLientRoleID: 2,
                _Permission: 920,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 90,
                _AppCLientRoleID: 2,
                _Permission: 1000,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 91,
                _AppCLientRoleID: 2,
                _Permission: 1100,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 92,
                _AppCLientRoleID: 2,
                _Permission: 1200,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 93,
                _AppCLientRoleID: 2,
                _Permission: 1300,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
              {
                AppCLientPermissionID: 94,
                _AppCLientRoleID: 2,
                _Permission: 1400,
                _AppCLientRole: null,
                _SysNumber: 2986943897,
              },
            ],
          },
        ],
      },
      {
        _AosSysNumber: "LPFSHQP1",
        _EnterpriseName: "DEV Environment",
        SysNumber: 2986943897,
      },
    ];
  }
}
